import { render, staticRenderFns } from "./message_template_table.vue?vue&type=template&id=71ffeaa9&scoped=true"
import script from "./message_template_table.vue?vue&type=script&lang=ts"
export * from "./message_template_table.vue?vue&type=script&lang=ts"
import style0 from "./message_template_table.vue?vue&type=style&index=0&id=71ffeaa9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71ffeaa9",
  null
  
)

export default component.exports